/**
 * @file Pub Matching related actions.
 */
import { LeaseNumberRecVotes } from '../../graphql/queries/votes';
import {
  COMMAND_PUB_MATCHING_VOTE_STATUS,
  PUB_MATCHING_VOTE_LIMIT,
} from '../../constants/command';
import { getErrorString } from '../../../../util/normalize-errors';
import getLogger from '../../../../util/logger';

const log = getLogger('PubMatchingActions');

export const PUBMATCHING_FETCH_VOTES_REQUEST =
  'pub-matching/PUBMATCHING_FETCH_VOTES_REQUEST';
export const PUBMATCHING_FETCH_VOTES_SUCCESS =
  'pub-matching/PUBMATCHING_FETCH_VOTES_SUCCESS';
export const PUBMATCHING_VOTE_ADD_PUBBOX =
  'pub-matching/PUBMATCHING_VOTE_ADD_PUBBOX';
export const PUBMATCHING_VOTE_UPDATE_PUBBOX =
  'pub-matching/PUBMATCHING_VOTE_UPDATE_PUBBOX';
export const PUBMATCHING_VOTE_DELETE_PUBBOX =
  'pub-matching/PUBMATCHING_VOTE_DELETE_PUBBOX';
export const PUBMATCHING_VOTE_CAST = 'pub-matching/PUBMATCHING_VOTE_CAST';
export const PUBMATCHING_VOTES_CAST_SUCCESS =
  'pub-matching/PUBMATCHING_VOTES_CAST_SUCCESS';
export const PUBMATCHING_VOTES_CAST_FAILURE =
  'pub-matching/PUBMATCHING_VOTES_CAST_FAILURE';

const fetchVotesRequest = () => ({
  type: PUBMATCHING_FETCH_VOTES_REQUEST,
});

const fetchVotesSuccess = lease => ({
  type: PUBMATCHING_FETCH_VOTES_SUCCESS,
  lease,
});

const castPubMatchingVotesSuccess = votes => ({
  type: PUBMATCHING_VOTES_CAST_SUCCESS,
  votes,
});

const castPubMatchingVotesFailure = error => ({
  type: PUBMATCHING_VOTES_CAST_FAILURE,
  error,
});

export const pubMatchingVotePubBoxAdd = (voteId, pubBox) => ({
  type: PUBMATCHING_VOTE_ADD_PUBBOX,
  voteId,
  pubBox,
});

export const pubMatchingVotePubBoxUpdate = (voteId, pubBox) => ({
  type: PUBMATCHING_VOTE_UPDATE_PUBBOX,
  voteId,
  pubBox,
});

export const pubMatchingVotePubBoxDelete = (voteId, pubBox) => ({
  type: PUBMATCHING_VOTE_DELETE_PUBBOX,
  voteId,
  pubBox,
});

export const pubMatchingVoteCast = (voteId, status) => ({
  type: PUBMATCHING_VOTE_CAST,
  voteId,
  status,
});

const transformPhotoToPubMatchingVote = photo => {
  return {
    ...photo,
    status: COMMAND_PUB_MATCHING_VOTE_STATUS.NO_ACTION,
  };
};

export const fetchPubMatchingVotes = client => async dispatch => {
  dispatch(fetchVotesRequest());

  const {
    data: { leaseHlPubBoxPhotos },
  } = await client.query({
    query: LeaseNumberRecVotes,
    fetchPolicy: 'network-only',
    variables: {
      limit: PUB_MATCHING_VOTE_LIMIT,
    },
  });

  dispatch(
    fetchVotesSuccess({
      lease_id: leaseHlPubBoxPhotos.lease_id,
      expiresAt: leaseHlPubBoxPhotos.lease_expires_at,
      votes: leaseHlPubBoxPhotos.photos.map(transformPhotoToPubMatchingVote),
      album: leaseHlPubBoxPhotos.album,
    }),
  );
};

/**
 * Performs actual mutation to cast votes within our platform.
 *
 * @param {Array<Object>} votes List of votes to cast.
 * @param {Function} pubMatchingCastVotesMutation Mutation for pubMatchingCastVotes.
 */
export const castPubMatchingVotes =
  (votes, pubMatchingCastVotesMutation) => async dispatch => {
    log.info('castPubMatchingVotes :: Votes to be cast: ', votes);

    try {
      await pubMatchingCastVotesMutation({
        photos: votes.map(({ id }) => ({
          photo_id: id,
        })),
      });
      dispatch(castPubMatchingVotesSuccess(votes));
    } catch (error) {
      log.error(error);
      castPubMatchingVotesFailure(getErrorString(error));
    }
  };
